<template>
  <v-container class="layout-container">
    <Valuation />
  </v-container>
</template>

<script>
import Valuation from '@/modules/valuation/Valuation.vue'

export default {
  components: {
    Valuation,
  },
}
</script>
